import { inject, Injectable } from '@angular/core';
import {
  CheckLocationRequest,
  CheckLocationResponse,
} from '../interfaces/reserve-location.model';
import { API_ENDPOINTS } from '../constants/api.constants';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../interfaces/api-response.model';

@Injectable({
  providedIn: 'root',
})
export class ReserveLocationService {
  http: HttpClient = inject(HttpClient);

  /**
   * 查詢健檢中心，企業需帶 HIS 公司代碼
   * @param request 查詢健檢中心request model(預約類別/HIS 公司代碼)
   */
  checkLocations(
    request: CheckLocationRequest
  ): Observable<ApiResponse<CheckLocationResponse>> {
    let requestUrl = new HttpParams().set(
      'reservationType',
      request.reservationType
    );

    if (request.reservationType === '2' && request.companyNo) {
      requestUrl = requestUrl.set('companyNo', request.companyNo);
    }

    return this.http.get<ApiResponse<CheckLocationResponse>>(
      API_ENDPOINTS.CHECK_LOCATIONS,
      {
        params: requestUrl,
      }
    );
  }
}
